export default "__VITE_ASSET__BjUaqFZg__"